import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/orders-detail';

// See the pdf of the formula of some color
export const viewPDFColor = async (orderDetail) => {
    return await sendFetch(`${BASE_PATH}/pdf-color`, POST_OPTIONS, orderDetail);
}


// See the pdf of qr of some product
export const viewPDFQr = async (body) => {
    return await sendFetch(`${BASE_PATH}/pdf-qr`, POST_OPTIONS, body);
}

export const reprogram = async (body) => {
    return await sendFetch(`${BASE_PATH}/reprogram`, POST_OPTIONS, body);
}

export const pdfReel = async (body) => {
    return await sendFetch(`${BASE_PATH}/pdf-reel`, POST_OPTIONS, body);
}

export const literformula = async (body) => {
    return await sendFetch(`${BASE_PATH}/liter-formula`, POST_OPTIONS, body);
}
export const viewInfoDetails = async (body) => {
    return await sendFetch(`${BASE_PATH}/info-details`, POST_OPTIONS, body);
}
export const pdfBox = async (body) => {
    return await sendFetch(`${BASE_PATH}/pdf-box`, POST_OPTIONS, body);
}

export const regroup = async (body) => {
    return await sendFetch(`${BASE_PATH}/regroup`, POST_OPTIONS, body);
}

export const findOrderDetailById = async (id) => {
    return await sendFetch(`${BASE_PATH}/id/${id}`, GET_OPTIONS);
}

export const processRemission = async (body) => {
    return await sendFetch(`${BASE_PATH}/process-remission`, POST_OPTIONS, body);
}

export const updateOrderDetail = async (body) => {
    return await sendFetch(`${BASE_PATH}/update`, POST_OPTIONS, body);
}

export const readyOrderDetail = async (body) => {
    return await sendFetch(`${BASE_PATH}/ready`, POST_OPTIONS, body);
}

export const findOrderDetailForWeavingPendingCrudeRolled = async () => {
    return await sendFetch(`${BASE_PATH}/all-weaving-rolled/pending`, GET_OPTIONS);
}